import React from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import CollapsibleTableRow from './CollapsibleTableRow';
import TotalsTableCells from './TotalsTableCells';


interface PivotTableRowProps {
  row: {
    [quarter: string]: {
      [month: string]: {
        [week: string]: [ISalesAnnualComparisonByWeek];
      }
    }
  }
  heading: string;
}

const PivotTableRow: React.FC<PivotTableRowProps> = (props) => {
  const { row, heading } = props;

  const weekDateName = (week) => {
    return week.split('/').map((date) => {
      const [, month, day] = date.split('-');
      return `${month}/${day}`;
    }).join(' - ');
  };

  return (
    <>
      <CollapsibleTableRow title={heading} data={row} leftGap={0} >
        {Object.keys(row).map((quarter) => (
          <CollapsibleTableRow key={quarter} title={quarter} data={row[quarter]} leftGap={2} >
            {Object.keys(row[quarter]).map((month) => (
              <CollapsibleTableRow key={month} title={month} data={row[quarter][month]} leftGap={4}>
                {Object.keys(row[quarter][month]).map((week) => (
                  <TableRow key={week}>
                    <TableCell className="pl-11" width="150px">{weekDateName(row[quarter][month][week][0].week)}</TableCell>
                    <TotalsTableCells totals={row[quarter][month][week][0]} showIndicators />
                  </TableRow>
                ))}
              </CollapsibleTableRow>
            ))}
          </CollapsibleTableRow>
        ))}
      </CollapsibleTableRow>
    </>
  );
};

export default PivotTableRow;
